import { useState } from "react";
import { Download, FileSpreadsheet, Image as ImageIcon, Loader2, Paperclip } from "lucide-react";
import apiClient from "@/api/client";
import type { AronFileResult as FileT } from "../types";
import { downloadBlob } from "@/utils/download";

function iconFor(ct: string) {
  if (ct.startsWith("image/")) return ImageIcon;
  if (ct.includes("sheet") || ct.includes("excel") || ct.includes("csv")) return FileSpreadsheet;
  return Paperclip;
}

// The proxy endpoint requires JWT auth, so a plain <a download> (no Authorization
// header) would 401 — fetch the blob through apiClient and trigger the download.
export function AronFileResult({ file }: { file: FileT }) {
  const [loading, setLoading] = useState(false);
  const Icon = iconFor(file.content_type || "");

  const download = async () => {
    setLoading(true);
    try {
      const path = file.url.replace(/^\/api\/v1/, "");
      const r = await apiClient.get(path, { responseType: "blob" });
      downloadBlob(r.data as Blob, file.filename || "plik");
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={download}
      disabled={loading}
      className="inline-flex items-center gap-1.5 rounded-md border border-gray-200 px-2 py-1 text-xs text-gray-700 hover:bg-gray-50 disabled:opacity-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
    >
      {loading ? <Loader2 size={13} className="animate-spin" /> : <Icon size={13} />}
      <span className="max-w-[220px] truncate">{file.filename || "plik"}</span>
      <Download size={12} className="opacity-60" />
    </button>
  );
}
